import React, { useEffect, useState } from "react";
import bgimage from "../../assets/game/background.png";
import rock from "../../assets/game/rock.png";
import characterImage from "../../assets/game/character.png";
import NextPage from "../../assets/game/Next Arrow Button.gif";
import BackPage from "../../assets/game/BackArrow.gif";
import KnowMore from "../../assets/game/Know More.png";
import Bronze from "../../assets/game/loyalty rewards/bronzeL.png";
import Sliver from "../../assets/game/loyalty rewards/Sliver.png";
import SliverLocked from '../../assets/game/loyalty rewards/sliverL.png'
import Gold from '../../assets/game/loyalty rewards/Gold.png'
import GoldLocked from '../../assets/game/loyalty rewards/GoldL.png'
import Platinum from  '../../assets/game/loyalty rewards/Platinum.png'
import PlatinumLocked from  '../../assets/game/loyalty rewards/sliverL.png'
import BackArrow from '../../assets/game/backArrow.png'
import NextArrow from '../../assets/game/NextArrow.png'
import flagImage from '../../assets/game/targetFlag.png'
import Gift from  '../../assets/game/gift.png'
import Board from '../../assets/game/offerBoard.png'
import pathFill from "../../assets/game/pathF.png";
import pathEmpty from "../../assets/game/pathE.png";
import Clock from '../../assets/game/clock.png'
import path1 from "../../assets/game/path1.png";
import path2 from "../../assets/game/path2.png";
import path3 from "../../assets/game/path3.png";
import path4 from "../../assets/game/path4.png";
import path5 from "../../assets/game/pathF.png";
import { useNavigate } from "react-router-dom";
const rocks = [
    { top: "64%", left: "7%" },
    { top: "32%", left: "20%" },
    { top: "64%", left: "41%" },
    { top: "32%", left: "60%" },
    { top: "64%", left: "77%" },
  ];
const Game = ({data,route,tagOrder,setGameguidelines}) => {
  const navigate=useNavigate()
 
   const milestonesPerPage = 5; //always fix
//console.log("data",data)
  const [currentPage, setCurrentPage] = useState(1);
  const [currentLevelMilestoneCount,setCurrentLevelMilestoneCount]=useState(1)
  const [levelRewards,setLevelReward]=useState([])
  const [levelId,setLevalId]=useState(1)
  const [daysLeft,setDaysLeft]=useState(1)
useEffect(() => {
  if (data?.currentLevelMilestoneCount) {
    setCurrentPage(Math.ceil(data.currentLevelMilestoneCount / milestonesPerPage));
  }
  if(data?.currentLevelMilestoneCount){
    setCurrentLevelMilestoneCount(data.currentLevelMilestoneCount)
  }

  if(data?.levelId)
  {
   setLevalId(data?.levelId) 
  }

  if(data?.daysLeft){
    setDaysLeft(data?.daysLeft)
  }

  if(data?.levelRewards){
    setLevelReward(data?.levelRewards)
  }
}, [data]);

 const totalMilestones = data?.totalMilestones;
 //console.log("totalMilestones",totalMilestones)
  const totalPages = Math.ceil(totalMilestones / milestonesPerPage);

  // Example: milestones completed so far
 

  // Numbering rocks
 // console.log("currentPage",currentPage,data?.currentLevelMilestoneCount)
  const startNumber = (currentPage - 1) * rocks.length + 1;

  
  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };


  // State


  // Path images for partial milestones
  const partialPaths = [path1, path2, path3, path4, path5];

  const getPagePathImage = () => {
    const currentMilestonePage = Math.ceil(currentLevelMilestoneCount / milestonesPerPage);

    if (currentLevelMilestoneCount >= totalMilestones) return pathFill;
    if (currentPage < currentMilestonePage) return pathFill;
    if (currentPage > currentMilestonePage) return pathEmpty;

    const index = (currentLevelMilestoneCount - 1) % milestonesPerPage;
    return partialPaths[index] || pathEmpty;
  };

  
  const Medal = () => {
    const [allmodelShow, SetallmodelShow] = useState(false);
  
    const handleShowAllModels = () => {
      SetallmodelShow(!allmodelShow);
    };
  

 
    
  
    return (
      <>
        <div
          style={{
          
            height: "10vw",
            position: "absolute",
            top: "12px",
            display:"flex"
          }}
        >
          <div style={{ display: "flex", padding: "5%", alignItems: "center" }}>
            <div>
              {levelId>=1&&<img src={Bronze} style={{ padding:"5%",width: "10vw" }} />}
              <h1 style={{fontFamily: "Roboto",
fontSize: "12px",
fontWeight: "700",    marginTop: "-5px",color:"black"}}>Bronze</h1>
            </div>
            <div>
             { (levelId>=2)?<img src={Sliver} style={{ width: "10vw", padding:"5%",}} />:<img src={SliverLocked} style={{ padding:"5%",width: "10vw", }} />}
              <h1 style={{fontFamily: "Roboto",
fontSize: "12px",
fontWeight: "700",    marginTop: "-3px",color:"black",marginLeft:"4px",}}>Sliver</h1>
            </div>
            <div
              style={{
                width: (levelId>=3)?"10vw":"10vw",
                display: allmodelShow ? "block" : "none",
                opacity: allmodelShow ? 1 : 0,
                transition: "opacity 5s ease-in-out",
                
              }}
            >
              {(levelId>=3)?<img src={Gold} style={{ padding:"5%",width: "100%" }} />:<img src={GoldLocked} style={{ width: "100%",padding:"5%", }} />}
              <h1 style={{fontFamily: "Roboto",
fontSize: "12px",
fontWeight: "700",color:"black",marginLeft:(levelId>=3)?"2px":"4px",marginTop:(levelId>=3)?"0px":"0px"}}>Gold</h1>
            </div>
            <div
              style={{
                width: "10vw",
                display: allmodelShow ? "block" : "none",
                opacity: allmodelShow ? 1 : 0,
                transition: "opacity 5s ease-in-out",
            
              }}
            >
           {(levelId>=4)?<img src={Platinum} style={{ padding:"5%",width: "100%" }} />:<img src={PlatinumLocked} style={{ padding:"5%",width: "100%" }} />}
              <h1 style={{fontFamily: "Roboto",
fontSize: "12px",
fontWeight: "700", color:"black",marginTop: "-2px"}}>Platinum</h1>
            </div>
            <div
              style={{
                width: "5vw",
                display: allmodelShow ? "flex" : "none",
                opacity: allmodelShow ? 1 : 0,
                transition: "opacity 5s ease-in-out",
                   marginTop: "-5px"
              }}
              onClick={handleShowAllModels}
            >
              <img src={BackArrow} style={{ width: "100%" }} />
            </div>
            <div
              style={{
                width: "5vw",
                display: allmodelShow ? "none" : "flex",
                opacity: allmodelShow ? 0 : 1,
                transition: "opacity 5s ease-in-out",
                    marginTop: "-5px"
              }}
              onClick={handleShowAllModels}
            >
              <img src={NextArrow} style={{ width: "100%" }} />
            </div>
          </div>
      
        </div>
        <div style={{    position: "absolute",
    right: "0",
    top: "1vw"}}>

<img src={Clock} style={{width:"100px"}}/>
<h2 style={{color:"white",   
    textAlign: "center",
    position: "absolute",
    top: "0",
    right: "8px",
    fontWeight: "bold",fontSize:"16px",
        lineHeight: "20px"
   }}>
Days <br/>{daysLeft}{" "}Left
</h2>
</div>
      </>
    );
  };

   const handleClcik=()=>{
    if(tagOrder){
     setGameguidelines(true)
    }
    else{
      navigate(`/guideLines?tagOrder=true`)
    }
    }
/* const Gift_ = () => {
  const gifts = [
    { top: "67%", left: "17%" },
    { top: "35%", left: "30%" },
    { top: "67%", left: "51%" },
    { top: "35%", left: "70%" },
    { top: "67%", left: "85%" },
  ];

  return (
    <>
      {gifts.map((pos, index) =>
        true? (
          <img
            key={index}
            src={Gift}
            alt={`Gift ${index + 1}`}
            style={{
              position: "absolute",
              top: pos.top,
              left: pos.left,
              width: "15vw",
              height: "auto",
              transform: "translate(-50%, -50%)",
            }}
          />
        ) : null
      )}
    </>
  );
};

const Board_ = () => {
  const board_ = [
    { top: "65%", left: "12%" },
    { top: "31%", left: "30%" },
    { top: "65%", left: "51%"},
    { top: "31%", left: "70%"},
    { top: "65%", left: "90%" },
  ];

  return (
    <>
      {board_.map((pos, index) => (
        <div
          key={index}
          style={{
            position: "absolute",
            top: pos.top,
            left: pos.left,
            transform: "translate(-50%, -50%)",
            width: "15vw",
            textAlign: "center",
          }}
        >
          
          <img
            src={Board}
            alt={`Board ${index + 1}`}
            style={{
              width: "100%",
              height: "auto",
              display: "block",
            }}
          />

          
          <span
            style={{
              position: "absolute",
              top: "33%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              color: "#fff",
              fontWeight: "bold",
              fontSize: "2.5vw",
              textShadow: "2px 2px 4px rgba(0,0,0,0.7)",
              fontFamily: "Roboto, sans-serif",
              pointerEvents: "none", // allows clicking image through
            }}
          >
            10% <b/> CashBack
          </span>
        </div>
      ))}
    </>
  );
}; */

const Character = () => {
  const Character_ = [
    { top: "57%", left: "24%" },
    { top: "62%", left: "37%" },
    { top: "59%", left: "62%" },
    { top: "61%", left: "77%" },
    { top: "65%", left: "90%" },
  ];

  // Each page shows 5 milestones (0–4)
  const startMilestone = (currentPage - 1) * milestonesPerPage + 1;
  const endMilestone = startMilestone + milestonesPerPage - 1;

  // Check if character milestone lies on this page
  if (
    currentLevelMilestoneCount < startMilestone ||
    currentLevelMilestoneCount > endMilestone
  ) {
    return null; // not on this page → don't render character
  }

  // Character index on this page (0–4)
  const characterPosition = (currentLevelMilestoneCount - 1) % milestonesPerPage;
  const pos = Character_[characterPosition];

  if (!pos) return null;

  return (
    <div
      style={{
        position: "absolute",
        top: pos.top,
        left: pos.left,
        transform: "translate(-50%, -50%)",
        width: "13vw",
        textAlign: "center",
        transition: "top 0.4s ease, left 0.4s ease", // optional smooth movement
      }}
    >
      <img
        src={characterImage}
        alt="Character"
        style={{
          width: "100%",
          height: "auto",
          display: "block",
        }}
      />
    </div>
  );
};



const GiftBoard_ = (  ) => {
  const positions = [
    { top: "67%", left: "17%" },
    { top: "35%", left: "30%" },
    { top: "67%", left: "51%" },
    { top: "35%", left: "70%" },
    { top: "67%", left: "85%" },
  ];

  const startMilestone = (currentPage - 1) * milestonesPerPage + 1;
  const endMilestone = startMilestone + milestonesPerPage - 1;

  return (
    <>
    {/* {console.log("levelRewards",levelRewards)} */}
      {levelRewards.map((milestone, index) => {
        const milestoneCount = milestone.milestoneCount;
        // Check if milestone belongs to current page
        if (milestoneCount < startMilestone || milestoneCount > endMilestone) return null;

        const posIndex = (milestoneCount - 1) % milestonesPerPage;
        const pos = positions[posIndex];
        if (!pos) return null;

        // Show gift or board
        if (milestone.isSurprise) {
          return (
            <img
              key={index}
              src={Gift}
              alt={`Gift ${milestoneCount}`}
              style={{
                position: "absolute",
                top: pos.top,
                left: pos.left,
                width: "15vw",
                height: "auto",
                transform: "translate(-50%, -50%)",
              }}
            />
          );
        } else  {
          return (
            <div
              key={index}
              style={{
                position: "absolute",
                top: pos.top,
                left: pos.left,
                transform: "translate(-50%, -50%)",
                width: "15vw",
                textAlign: "center",
              }}
            >
              <img
                src={Board}
                alt={`Board ${milestoneCount}`}
                style={{
                  width: "100%",
                  height: "auto",
                  display: "block",
                }}
              />
              <span
                style={{
                  position: "absolute",
                  top: "33%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  color: "#fff",
                  fontWeight: "bold",
                  fontSize: "2.5vw",
                  textShadow: "2px 2px 4px rgba(0,0,0,0.7)",
                  fontFamily: "Roboto, sans-serif",
                  pointerEvents: "none",
                }}
              >
                {milestone.value}% <b /> {milestone.rewardType}
              </span>
            </div>
          );
        }

        return null;
      })}
    </>
  );
};





const Flag_ = () => {
  const flagPositions = [
    { top: "70%", left: "96%" },
  ];
//console.log("isLastPage",currentPage, totalMilestones / milestonesPerPage)
  // Show flag only on the last page
  const isLastPage = currentPage === totalMilestones / milestonesPerPage;

  if (!isLastPage) return null;

  return (
    <>
      {flagPositions.map((pos, index) => (
        <div
          key={index}
          style={{
            position: "absolute",
            top: pos.top,
            left: pos.left,
            transform: "translate(-50%, -50%)",
            width: "11vw",
            textAlign: "center",
          }}
        >
          <img
            src={flagImage}
            alt={`Flag ${index + 1}`}
            style={{
              width: "100%",
              height: "auto",
              display: "block",
            }}
          />
        </div>
      ))}
    </>
  );
};




// ------------------- Gift Component -------------------
const Gift_ = ({ milestones,  }) => {
  const giftPositions = [
    { top: "67%", left: "17%" },
    { top: "35%", left: "30%" },
    { top: "67%", left: "51%" },
    { top: "35%", left: "70%" },
    { top: "67%", left: "85%" },
  ];

  const startMilestone = (currentPage - 1) * milestonesPerPage + 1;
  const endMilestone = startMilestone + milestonesPerPage - 1;

  return (
    <>
      {milestones.map((milestone, index) => {
        const milestoneCount = milestone.milestoneCount;

        if (
          milestone.isSurprise==true&&milestone.isRedeemed==false&&
          milestoneCount >= startMilestone &&
          milestoneCount <= endMilestone
        ) {
          const pos = giftPositions[(milestoneCount - 1) % milestonesPerPage];
          if (!pos) return null;

          return (
            <img
              key={index}
              src={Gift}
              alt={`Gift ${milestoneCount}`}
              style={{
                position: "absolute",
                top: pos.top,
                left: pos.left,
                width: "15vw",
                height: "auto",
                transform: "translate(-50%, -50%)",
              }}
            />
          );
        }
        return null;
      })}
    </>
  );
};

// ------------------- Board Component -------------------
const Board_ = ({ milestones }) => {
    //console.log("milestones",milestones)
  const boardPositions = [
    { top: "65%", left: "12%" },
    { top: "31%", left: "30%" },
    { top: "65%", left: "51%" },
    { top: "31%", left: "70%" },
    { top: "65%", left: "90%" },
  ];

  const startMilestone = (currentPage - 1) * milestonesPerPage + 1;
  const endMilestone = startMilestone + milestonesPerPage - 1;

  return (
    <>
      {milestones.map((milestone, index) => {
        const milestoneCount = milestone.milestoneCount;

        if (
          milestone.isSurprise==true&&milestone.isRedeemed==true &&
          milestoneCount >= startMilestone &&
          milestoneCount <= endMilestone
        ) {
          const pos = boardPositions[(milestoneCount - 1) % milestonesPerPage];
          if (!pos) return null;

          return (
            <div
              key={index}
              style={{
                position: "absolute",
                top: pos.top,
                left: pos.left,
                transform: "translate(-50%, -50%)",
                width: "15vw",
                textAlign: "center",
              }}
            >
              <img
                src={Board}
                alt={`Board ${milestoneCount}`}
                style={{
                  width: "100%",
                  height: "auto",
                  display: "block",
                }}
              />
              <span
                style={{
                  position: "absolute",
                  top: "33%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  color: "#fff",
                  fontWeight: "bold",
                  fontSize: "2.5vw",
                  textShadow: "2px 2px 4px rgba(0,0,0,0.7)",
                  fontFamily: "Roboto, sans-serif",
                  pointerEvents: "none",
                }}
              >
                ₹{" "}{Number(milestone.value).toFixed(2)}
<b /> {milestone.rewardType}
              </span>
            </div>
          );
        }


        if (
          milestone.isSurprise==false&&milestone.isRedeemed==true&&
          milestoneCount >= startMilestone &&
          milestoneCount <= endMilestone
        ) {
          const pos = boardPositions[(milestoneCount - 1) % milestonesPerPage];
          if (!pos) return null;

          return (
            <div
              key={index}
              style={{
                position: "absolute",
                top: pos.top,
                left: pos.left,
                transform: "translate(-50%, -50%)",
                width: "15vw",
                textAlign: "center",
              }}
            >
              <img
                src={Board}
                alt={`Board ${milestoneCount}`}
                style={{
                  width: "100%",
                  height: "auto",
                  display: "block",
                }}
              />
              <span
                style={{
                  position: "absolute",
                  top: "33%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  color: "#fff",
                  fontWeight: "bold",
                  fontSize: "2.5vw",
                  textShadow: "2px 2px 4px rgba(0,0,0,0.7)",
                  fontFamily: "Roboto, sans-serif",
                  pointerEvents: "none",
                }}
              >
                ₹{" "}{Number(milestone.value).toFixed(2)}
<b /> {milestone.rewardType}
              </span>
            </div>
          );
        }


        
        if (
          milestone.isSurprise==false&&milestone.isRedeemed==false &&
          milestoneCount >= startMilestone &&
          milestoneCount <= endMilestone
        ) {
          const pos = boardPositions[(milestoneCount - 1) % milestonesPerPage];
          if (!pos) return null;

          return (
            <div
              key={index}
              style={{
                position: "absolute",
                top: pos.top,
                left: pos.left,
                transform: "translate(-50%, -50%)",
                width: "15vw",
                textAlign: "center",
              }}
            >
              <img
                src={Board}
                alt={`Board ${milestoneCount}`}
                style={{
                  width: "100%",
                  height: "auto",
                  display: "block",
                }}
              />
              <span
                style={{
                  position: "absolute",
                  top: "33%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  color: "#fff",
                  fontWeight: "bold",
                  fontSize: "2.5vw",
                  textShadow: "2px 2px 4px rgba(0,0,0,0.7)",
                  fontFamily: "Roboto, sans-serif",
                  pointerEvents: "none",
                }}
              >
                ₹{" "}{Number(milestone.value).toFixed(2)}
<b /> {milestone.rewardType}
              </span>
            </div>
          );
        }


      
        return null;
      })}
    </>
  );
};



  const isLastPage = currentPage === totalMilestones / milestonesPerPage;

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        aspectRatio: "16/12",
        overflow: "hidden",
        marginBottom: "3vw",
        borderRadius: "10px",
      }}
    >
      {/* Background */}
      <img
        src={bgimage}
        alt="Background"
        style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }}
      />

      {/* Path overlay */}
      <img
        src={getPagePathImage()}
        alt="Path"
        style={{ position: "absolute", top: "41%", left: 0, width: "100%", height: "auto" }}
      />
<Medal/>
 <Gift_ milestones={levelRewards} />
<Board_  milestones={levelRewards}/> 
{/* <GiftBoard_/> */}
<Character/>
<Flag_/>
      {/* Rocks */}
      {rocks.map((pos, index) => (
        <div
          key={index}
          style={{
            position: "absolute",
            top: pos.top,
            left: pos.left,
            width: "18vw",
            height: "18vw",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img src={rock} alt={`Rock ${index + 1}`} style={{ width: "100%", height: "100%", objectFit: "contain" }} />
          <span
            style={{
              position: "absolute",
              color: "#fff",
              fontWeight: "bold",
              fontSize: "6vw",
            }}
          >
            {startNumber + index}
          </span>
        </div>
      ))}

      {/* Know More button */}
      <img 
      onClick={(e)=>{handleClcik()}}
        src={KnowMore}
        alt="Know More"
        style={{ position: "absolute", right: "0%", bottom: "0%", width: "25%", cursor: "pointer" }}
      />

      {/* Navigation buttons */}
      {!(currentPage==1)&&<img
        src={BackPage}
        alt="Previous"
        onClick={handlePrev}
        style={{ position: "absolute", left: "-4%", top: "37%", width: "20%", cursor: "pointer" }}
      />}
      {!(isLastPage)&&<img
        src={NextPage}
        alt="Next"
        onClick={handleNext}
        style={{ position: "absolute", right: "-4%", top: "37%", width: "20%", cursor: "pointer" }}
      />}
    </div>
  );
};

export default Game;
